import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
export function Services() {
  const services = [{
    title: 'Curriculum-Aligned SEO Audits',
    description: 'Deep technical and on-page audits tailored specifically to educational content structures, LMS platforms, and course catalogs.'
  }, {
    title: 'Learner-Intent Content Strategy',
    description: 'Comprehensive content calendars built around how prospective students actually search, research, and make enrollment decisions.'
  }, {
    title: 'Semantic Course Architecture',
    description: 'Structuring your course pages, categories, and metadata for maximum search visibility and logical user progression.'
  }, {
    title: 'Authority Link Building',
    description: 'Earning high-quality backlinks from educational institutions, edtech publications, and respected learning communities.'
  }, {
    title: 'Performance Analytics & Reporting',
    description: 'Monthly dashboards tracking organic growth, keyword rankings, and most importantly, direct enrollment attribution.'
  }];
  return <section id="services" className="py-24 md:py-32 bg-cream-100 relative overflow-hidden" data-id="element-136">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-sage-100/40 to-transparent pointer-events-none" data-id="element-137" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-138">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start" data-id="element-139">
          <div className="lg:col-span-5 lg:sticky lg:top-32" data-id="element-140">
            <FadeIn data-id="element-141">
              <h2 className="text-sm font-bold tracking-widest text-lavender-800 uppercase mb-4" data-id="element-142">
                Our Methodology
              </h2>
              <h3 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight mb-6" data-id="element-143">
                How Cyberspire Bridges the Gap
              </h3>
              <p className="text-lg text-slate-600 leading-relaxed mb-8" data-id="element-144">
                We don't apply generic B2B marketing tactics to education. Our
                approach is built from the ground up for the unique architecture
                and user journey of e-learning platforms.
              </p>
              <a href="#pricing" onClick={e => {
              e.preventDefault();
              document.querySelector('#pricing')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="inline-flex items-center justify-center px-6 py-3 border-2 border-slate-900 text-slate-900 font-medium rounded-full hover:bg-slate-900 hover:text-white transition-colors" data-id="element-145">
                View Pricing Plans
              </a>
            </FadeIn>
          </div>

          <div className="lg:col-span-7" data-id="element-146">
            <StaggerContainer className="flex flex-col gap-6" data-id="element-147">
              {services.map((service, idx) => <StaggerItem key={idx} data-id="element-148">
                  <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-cream-200 hover:shadow-md transition-shadow" data-id="element-149">
                    <div className="flex gap-5" data-id="element-150">
                      <div className="flex-shrink-0 mt-1" data-id="element-151">
                        <CheckCircle2 className="text-sage-300" size={28} data-id="element-152" />
                      </div>
                      <div data-id="element-153">
                        <h4 className="text-xl font-serif font-medium text-slate-900 mb-3" data-id="element-154">
                          {service.title}
                        </h4>
                        <p className="text-slate-600 leading-relaxed" data-id="element-155">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}